import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DashboardState } from '@app/dashboard/state/dashboard.state';

export const getDashboardState =
  createFeatureSelector<DashboardState>('dashboard');

export const getActiveMyWorkTab = createSelector(
  getDashboardState,
  (state) => state.activeMyWorkTab,
);
export const getActiveMyTeamTab = createSelector(
  getDashboardState,
  (state) => state.activeMyTeamTab,
);

export const getActivePills = createSelector(
  getDashboardState,
  (state) => state.activePills,
);
